import { UPDATE_WINDOW_DIMENSION } from "../actions/windowDimensionsActions";

const initialState = {
  width: window.innerWidth,
  height: window.innerHeight,
  scrollPercent: 0,
};

export const windowDimensionReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_WINDOW_DIMENSION:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default windowDimensionReducer;
